export const maxUrlLength: number = 2048;

export const newCycleId: number = 0;

export const conversionPayFactor: number = 50;

export const defaultSearchResultLimit: number = 10;

export const requestNewTitleCode: string = '-';

export const requestNewTitleText: string = 'Request New Job';

export const emptyFunction = (): void => { };

export const defaultStandardWorkHours = 40;

export const defaultWeeksPerYear = 52;